<template>
<kt-input type="checkbox" data-switch="true" 
    v-bind:data-on-color="variant_on"
    v-bind:data-off-color="variant_off"
    v-bind:data-size="_size"
>
    <slot></slot>
</kt-input>
</template>

<script>
export default {
    props: {
        variant_on: {
            default: 'default'
        },
        variant_off: {
            default: 'default'
        },
        size: [String]
    },
    computed: {
        _size: function() {
            let _sizes = {
                'lg': 'large',
                'sm': 'small',
            }
            
            return this._sizes[this.size]
        }
    }
}
</script>